import React from "react";

/**
 * Cabecera de tabla interactiva con indicador de dirección de ordenación.
 */
export default function SortableHeader({
  label,
  columnKey,
  sortColumn,
  sortDirection,
  onSort,
  style,
}) {
  const isActive = columnKey === sortColumn;

  return (
    <th
      onClick={() => onSort(columnKey)}
      style={{
        cursor: "pointer",
        userSelect: "none",
        ...style,
      }}
      role="columnheader"
      aria-sort={isActive ? (sortDirection === "asc" ? "ascending" : "descending") : "none"}
    >
      {label}
      {isActive && (
        <span style={{ marginLeft: 4 }}>
          {sortDirection === "asc" ? "▲" : "▼"}
        </span>
      )}
    </th>
  );
}
